import LearnPageLayout from "@/components/LearnPageLayout";
import { pageBeyondMedication } from "./learnDataBeyondMedication";

const BeyondMedicationPage = () => (
  <LearnPageLayout
    title={pageBeyondMedication.title}
    description={pageBeyondMedication.description}
    canonical={pageBeyondMedication.canonical}
    h1={pageBeyondMedication.h1}
    breadcrumbLabel={pageBeyondMedication.breadcrumbLabel}
    crumbs={pageBeyondMedication.crumbs}
    shortAnswer={pageBeyondMedication.shortAnswer}
    keyTakeaways={pageBeyondMedication.keyTakeaways}
    sections={pageBeyondMedication.sections}
    faqs={pageBeyondMedication.faqs}
    sources={pageBeyondMedication.sources}
    schemaJson={pageBeyondMedication.schemaJson}
    relatedLinks={pageBeyondMedication.relatedLinks}
    reviewBlock={pageBeyondMedication.reviewBlock}
  />
);

export default BeyondMedicationPage;
